<template lang="pug">
.modal(
    tabindex="-1",
    role="dialog",
    :id="id",
    :data-backdrop="backdrop" 
)
    .modal-dialog(role="document")
        .modal-content
            .modal-header
                a.pull-right.text-muted.text-lg(data-dismiss="modal") ×
                h5.modal-title
                    slot(name="title")
            .modal-body
                    slot(name="body")
            .modal-footer
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    type="button",
                    data-dismiss="modal",
                    :disabled="loading"
                ) Close
                slot(name="footer")
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: 'bs3-modal',
        },

        loading: {
            type: Boolean,
            default: false,
        },
        backdrop: {
            type: String,
            default: 'static',
        },
    },

    mounted() {
        this.registerEvents();
    },

    methods: {
        show() {
            $(`#${this.id}`).modal('show');
        },

        hide() {
            $(`#${this.id}`).modal('hide');
        },

        registerEvents() {
            this.$on('show', () => {
                this.show();
            });

            this.$on('hide', () => {
                this.hide();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modal/modal.vue